export default __webpack_public_path__ + "static/media/SEA_7379.7b85716e.jpg";